module.exports = "/_next/static/images/9d7306deb31b7e2938120a8aef64d9e1-virtual-card-icon.svg";